import React from 'react';
import "./Footer.css";

const Footer = () => {
    return (
        <footer className="footer">
            <p>&copy; <span id="year"></span> DIWASA Portfolio. All rights reserved by IWMI.</p>
        </footer>
    );
};

export default Footer;
